var app = angular.module('leonardo');

var TsLiveboardDirective = function(ThoughtSpotService, $timeout) {
  return {
    restrict: 'A',
    scope: {
      vizId: '@?',
      fullHeight: '=?',
      params: '=?',
      fullApp: '=?' 
    },
    link: function(scope, element) {
      var ctrl = null;

      function render() {
    if (ctrl) { try { ctrl.destroy(); } catch(e) {} }

    ctrl = ThoughtSpotService.renderSmart(element[0], {
      vizId: scope.vizId,
      fullHeight: scope.fullHeight,
      params: scope.params,
      fullApp: scope.fullApp
    });
  }

      $timeout(render, 0);

      scope.$watchGroup(['fullApp', 'vizId', 'fullHeight'], function() {
        $timeout(render, 0);
      });

      scope.$on('$destroy', function() {
        if (ctrl) { ctrl.destroy(); ctrl = null; }
      });
    }
  };
};

app.directive('tsLiveboard', ['ThoughtSpotService', '$timeout', TsLiveboardDirective]);
